import unidadesService from "@/service/unidadesService";
import { usePagination } from "@/composables/usePagination";
import { ref } from "vue";

export function useUnidades() {
  const unidades = ref([]);
  const unidade = ref(null);
  const isLoading = ref(false);
  const isSaving = ref(false);

  const pagination = usePagination({
    initialPage: 0,
    pageSize: 10,
    baseIndex: 0,
  });

  const fetchAllUnidades = async (
    page = pagination.currentPage.value,
    size = 1000
  ) => {
    isLoading.value = true;
    try {
      const response = await unidadesService.getAllUnidades(page, size);
      unidades.value = response || [];
      pagination.currentPage.value = page;
      return response;
    } catch (error) {
      console.error("Erro ao buscar unidades:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchUnidadeById = async (unidadeId) => {
    isLoading.value = true;
    try {
      const response = await unidadesService.getUnidadesById(unidadeId);
      unidade.value = response;
      return response;
    } catch (error) {
      console.error("Erro ao buscar unidade por ID:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchUnidadesByNome = async (nome) => {
    isLoading.value = true;
    try {
      const response = await unidadesService.getUnidadesByNome(nome);
      unidades.value = response?.content ?? [];
      return response;
    } catch (error) {
      console.error("Erro ao buscar unidades por nome:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const saveUnidade = async (name) => {
    isSaving.value = true;
    try {
      const response = await unidadesService.postUnidades(name);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar unidade:", error);
    } finally {
      isSaving.value = false;
    }
  };

  return {
    unidades,
    unidade,
    isLoading,
    isLoadingUnidade: isLoading,
    isSaving,
    isSavingUnidade: isSaving,
    currentPage: pagination.currentPage,
    totalPages: pagination.totalPages,
    pageSize: pagination.pageSize,
    hasNextPage: pagination.hasNextPage,
    hasPreviousPage: pagination.hasPreviousPage,
    fetchAllUnidades,
    fetchUnidadeById,
    fetchUnidadesByNome,
    saveUnidade,
    nextPage: pagination.nextPage,
    previousPage: pagination.previousPage,
    goToPage: pagination.goToPage,
  };
}
